import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { ProductIntro } from './components/ProductIntro';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { EliteUpgrade } from './components/EliteUpgrade';
import { ComparisonTable } from './components/ComparisonTable';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
const FB_PIXEL_ID = '1545009850674181';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const initPixel = () => {
      try {
        // Official Meta Pixel base code (resilient: a failure loading the
        // external fbevents.js won't crash the app — e.g. in sandboxed previews).
        /* eslint-disable */
        ;
        (function (f: any, b: any, e: string, v: string, n?: any, t?: any, s?: any) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        (window as any).fbq('init', FB_PIXEL_ID);
        (window as any).fbq('track', 'PageView');
      } catch (e) {
        console.warn('Meta Pixel init skipped:', e);
      }
    };
    // Defer the external Facebook script so it never blocks first paint.
    const w = window as any;
    if (typeof w.requestIdleCallback === 'function') {
      const id = w.requestIdleCallback(initPixel, {
        timeout: 4000
      });
      return () => w.cancelIdleCallback?.(id);
    }
    const t = setTimeout(initPixel, 2500);
    return () => clearTimeout(t);
  }, []);
  return <div className="w-full min-h-screen bg-white font-sans text-gray-900 selection:bg-[#F97316] selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainSection data-id="element-4" />
      <ProductIntro data-id="element-5" />
      <TomosSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <EliteUpgrade data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <ExtendedTestimonials data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />

      <PurchasePopup data-id="element-16" />
    </div>;
}